import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { getUsersGroups } from 'projects/access-control/src/app/Infrastructure/Store/groups/groups.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ModalUsersComponent } from '../../../../components/modal-users/modal-users.component';

@Component({
	selector: 'app-users-groups',
	templateUrl: './users-groups.component.html',
	styleUrls: ['./users-groups.component.scss'],
})
export class UsersGroupsComponent implements OnInit, OnChanges, OnDestroy {
	@Input() group: Groups = {} as Groups;
	@Input() loading: boolean = false;

	pagination: DataPagination = {} as DataPagination;
	userTable: UsersGroups[] = [];
	subscriptionTranslate!: Subscription;
	translateUser: { buttonNew: string } = { buttonNew: '' };
	columns: any[] = [
		{ name: 'username', label: 'Username' },
		{ name: 'fullName', label: 'Full Name' },
		{ name: 'email', label: 'Email' },
		{ name: 'phone', label: 'Phone' },
	];
	constructor(
		private translateService: TranslateService,
		private store: Store,
		public dialog: MatDialog
	) {}

	ngOnInit(): void {
		this.getTranslate();
		this.store.dispatch(
			getUsersGroups({
				group: { pk: this.group.pk, sk: this.group.sk },
				paginationTo: 1,
			})
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (this.group?.dataUsers) {
			this.userTable = this.group.dataUsers.users.map((userElement) => {
				const status: UsersGroups = userElement as UsersGroups;
				return {
					...userElement,
					status: status.status,
				};
			});
			this.userTable = [...this.userTable];
			this.pagination = this.group.dataUsers.pagination;
		}
	}

	openDialogUser(type: string = 'newUser', user: UsersGroups = {} as UsersGroups) {
		const dialogRef = this.dialog.open(ModalUsersComponent, {
			height: '750px',
			width: '600px',
			data: { type, group: this.group, user },
		});
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateUser = data.pages.groups.tabs.infoTabs.users;
			this.columns = data.pages.groups.tabs.infoTabs.users.columsFilter;
		});
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
